import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import styled from 'styled-components'
import ExperienceYAMLList from '../ExperienceLists/ExperienceYAMLList'
import Image from 'components/Common/Image'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useExperienceSearchUrl from 'hooks/Experiences/useExperienceSearchUrl'

const MoreOffersSection = styled.div`
  padding: ${rem(40)};
  text-align: center;

  > * + * {
    margin-top: ${rem(8)};
  }

`

const UnavailableTile = styled.div`
  padding: ${rem(20)} 0;
  display: grid;
  grid-template-columns: ${rem(84)} 1fr;

  ${mediaQueryUp.tablet} {
    padding: 0;
    grid-template-columns: ${rem(230)} 1fr;
    height: ${rem(120)};
    align-items: center;
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
    border-radius: ${props => props.theme.borderRadius.M};
    overflow: hidden;
  }
`

const TileContent = styled.div`
  padding: 0 ${rem(32)};

  ${mediaQueryUp.tablet} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

const TileImage = styled.div`
  height: ${rem(84)};

  ${mediaQueryUp.tablet} {
    height: ${rem(120)};
  }

`

interface Props {
  experience: App.ExperienceOffer
}

function ExperienceOfferPageUnavailableHeader(props: Props) {
  const { experience } = props

  const [browseAllUrl] = useExperienceSearchUrl({ latLong: experience.location })

  return <VerticalSpacer gap={40}>
    <UnavailableTile>
      <TileImage>
        <Image
          image={experience.images[0]}
          height={120}
          width={220}
          fit="center"
        />
      </TileImage>
      <TileContent>
        <div>
          <Heading variant="heading5">
            Sorry, this {experience.productType === 'flash' ? ' limited time' : undefined}{' '}
            offer has sold out!
          </Heading>
          <BodyText variant="small">{experience.name}</BodyText>
        </div>
        <CSSBreakpoint max="mobile">
          <TextButton kind="tertiary" horizontalOutdent="start" href="#offer-details">
            View offer details
          </TextButton>
        </CSSBreakpoint>
        <CSSBreakpoint min="tablet">
          <TextButton kind="tertiary" horizontalOutdent="end" href="#offer-details">
            View offer details
          </TextButton>
        </CSSBreakpoint>
      </TileContent>
    </UnavailableTile>
    <VerticalSpacer gap={20}>
      <Heading variant="heading3">
        Similar offers around {experience.location.name} you may also like
      </Heading>
      <ExperienceYAMLList experience={experience} />
    </VerticalSpacer>
    <MoreOffersSection>
      <Heading variant="heading6">
        More exclusive offers available in {experience.location.name}
      </Heading>
      <TextButton kind="secondary" to={browseAllUrl}>
        Browse all offers
      </TextButton>
    </MoreOffersSection>
  </VerticalSpacer>
}

export default ExperienceOfferPageUnavailableHeader
